import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import { orderSystemNotificationStore } from '../../store';
import { LOCALES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import MultiLanguageTextArea from 'src/view/components/Controls/MultiLanguageTextArea/MultiLanguageTextArea';
import Text, { TEXT } from 'src/view/components/Text/Text';

const OrderSystemNotificationRefundBlock: FC = observer((): JSX.Element => {
  const onChangeValue = useCallback(
    (value: string, currentLanguage: LOCALES) => {
      orderSystemNotificationStore.changeNotification({
        refund: { ...orderSystemNotificationStore.notification.refund, [currentLanguage]: value },
      });
    },
    [orderSystemNotificationStore.notification.refund]
  );

  return (
    <div className="d-flex flex-column gap-10">
      <Text
        type={TEXT.SECTION_HEADER}
        text="refund_msg_block_header"
        tooltip={{
          message: 'refund_msg_block_header_infotip',
          position: TOOLTIP_POSITION.FIXED,
          duration: TOOLTIP_DURATION.EXTRA_LARGE,
          iconSize: 20,
        }}
      />

      <Text type={TEXT.BLOCK_HEADER} text="refund_msg_input_field_label" required className="mt-2" />
      <MultiLanguageTextArea
        enText={orderSystemNotificationStore.notification.refund.en}
        arText={orderSystemNotificationStore.notification.refund.ar}
        onChangeValue={onChangeValue}
        validation={orderSystemNotificationStore.validation.refund}
        placeholder={localeStore.t('hint_message')}
        className="order-system-notification__text-area"
        textAreaClassName="order-system-notification__text-area-input"
      />
    </div>
  );
});

export default OrderSystemNotificationRefundBlock;
